import { memo } from 'react'
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params'
import { Offer } from '../../../domain/dtos/offer'
import { SubscriptionStatus } from '../../../domain/enums/subscription-status'
import { CommaDelimitedArrayParam } from '../../utils/query-string-encoder'
import { Filters } from './filters'
import { SubscriptionsTable as Table } from './subscriptions-table'

type SubscriptionsProps = {
  offers: Offer[]
  isFetching: boolean
  isLoading: boolean
}

export const SubscriptionsTable = memo(({ offers, isFetching, isLoading }: SubscriptionsProps) => {
  const isFetchingOffers = isFetching || isLoading

  const [filters, setFilters] = useQueryParams({
    search: withDefault(StringParam, ''),
    dateRangeBy: withDefault(StringParam, 'createdAt'),
    startDate: withDefault(StringParam, ''),
    endDate: withDefault(StringParam, ''),
    statuses: withDefault(CommaDelimitedArrayParam, [
      SubscriptionStatus.ACTIVE,
      SubscriptionStatus.CANCELED,
      SubscriptionStatus.INACTIVE,
    ]),
    offerIds: withDefault(CommaDelimitedArrayParam, []),
    page: withDefault(NumberParam, 1),
    pageSize: withDefault(NumberParam, 25),
    planType: withDefault(CommaDelimitedArrayParam, []),
  })

  return (
    <div className="flex flex-col gap-4 mt-4">
      <Filters filters={filters} setFilters={setFilters} offers={offers} isLoading={isFetchingOffers} />
      <Table filters={filters} offers={offers} offersLoading={isFetchingOffers} />
    </div>
  )
})
